import { useState } from "react";
import { ENROLLMENT_STEPS_NUMBER } from "constants/enrollment";

export function useEnrollmentSteps(initialStep = ENROLLMENT_STEPS_NUMBER.ELIGIBILITY_CHECK) {
    const [activeStep, setActiveStep] = useState(initialStep);
    const [showMoreInfo, setShowMoreInfo] = useState(false);
    const [errorScreen, setErrorScreen] = useState(null);

    const resetToInitialStep = (resetForm) => {
        setErrorScreen(null);
        setShowMoreInfo(false);
        setActiveStep(ENROLLMENT_STEPS_NUMBER.ELIGIBILITY_CHECK);
        if (resetForm) resetForm();
    };

    return {
        activeStep,
        setActiveStep,
        showMoreInfo,
        setShowMoreInfo,
        errorScreen,
        setErrorScreen,
        resetToInitialStep,
    };
}
